import React from "react";
import { Box, Card, Grid, Text, PageHeading } from "atoms";
import { ProfileChnagePasswordForm, ProfileDetailForm } from "molecules";

const Profile = () => {
  return (
    <Box>
      <PageHeading text="Profile" mt="1.8rem" />
      <Grid
        gridTemplateColumns="1fr 1fr"
        gridGap="2.4rem"
        mt="3rem"
        alignItems="start"
      >
        <Card>
          <Text
            fontSize="2rem"
            color="primary.900"
            fontFamily="NeometricExtraBold"
            borderBottom="1px solid"
            borderColor="neutral.100"
            pb="1.6rem"
          >
            Details
          </Text>
          <ProfileDetailForm />
        </Card>
        <Card>
          <Text
            fontSize="2rem"
            color="primary.900"
            fontFamily="NeometricExtraBold"
            borderBottom="1px solid"
            borderColor="neutral.100"
            pb="1.6rem"
          >
            Change Password
          </Text>
          <ProfileChnagePasswordForm />
        </Card>
      </Grid>
    </Box>
  );
};

export default Profile;
